import { useRef, useLayoutEffect, useState } from "react";

const isBrowser = typeof window !== `undefined`;

const getScrollPosition = ({ element, useWindow }: any) => {
	if (!isBrowser) return { x: 0, y: 0 };
	const target = element ? element.current : document.body;
	const value = target.pageYOffset || target.scrollTop;

	return useWindow ? window.scrollY : value;
};

let throttleTimeout: any = null;

export default (wait?: number, useWindow?: boolean) => {
	const element = useRef<HTMLDivElement>(null);
	const [value, setValue] = useState(0);

	useLayoutEffect(() => {
		if (!element || !element.current) return;

		const callBack = () => {
			const currPos = getScrollPosition({ element, useWindow });
			setValue(currPos);
			throttleTimeout = null;
		};

		const handleScroll = () => {
			if (wait) {
				if (throttleTimeout === null) {
					throttleTimeout = setTimeout(callBack, wait);
				}
			} else {
				callBack();
			}
		};

		element.current.addEventListener("scroll", handleScroll);
	}, [wait, useWindow]);

	return { element, value };
};
